<iris-modal-chrome
  [title]="title"
  [showTitle]="showTitle"
  [ariaLabel]="ariaLabel"
  [showHeader]="showHeader"
  [isDismissable]="isDismissable"
  [closeOnBackdropClick]="closeOnBackdropClick"
  [customStyles]="customStyles"
  (dismissRequested)="close()"
>
  <ng-container *ngIf="contentType === contentTypeEnum.TEMPLATE">
    <ng-container *ngTemplateOutlet="contentTemplate; context: $any(context)"></ng-container>
  </ng-container>

  <ng-container *ngIf="contentType === contentTypeEnum.COMPONENT">
    <ng-container *ngComponentOutlet="contentComponent"></ng-container>
  </ng-container>
</iris-modal-chrome>
